import Icon from '../components/Icon.vue'

Icon.register({
  'hand-spock': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M481.3 97.1c21.4 5.1 34.7 26.7 29.7 48.2l-36.3 152.5c-1.7 7.2-2.6 14.7-2.6 22.2v42c0 9.3-1.4 18.4-4 27.3l-26.2 88.3c-6 20.4-24.7 34.4-46 34.4h-216.7c-12.2 0-24-4.6-32.9-13l-133.7-125.9c-16.1-15.1-16.8-40.4-1.7-56.5 15.1-16.1 40.4-16.8 56.5-1.7l60.6 57v-79.4l-39-171.6c-4.9-21.6 8.6-43 30.1-47.9 21.6-4.9 43 8.6 47.9 30.1l34.8 152.8h9.8l-47.6-207c-5-21.5 8.5-43 30-47.9 21.6-4.9 43 8.5 48 30.1l51.7 224.9h15.1l48.4-193.7c5.4-21.4 27.1-34.5 48.5-29.1 21.4 5.4 34.5 27.1 29.1 48.5l-43.6 174.3h11.1l30.8-129.3c5.1-21.4 26.7-34.7 48.2-29.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/hand-spock.js
// module id = 1382
// module chunks = 0